const data = {
	pathname: 'centaline',
	filename: 'poster_1',
	bgColor: '#f6f6f6',
	color: '#9d6252',
	posters: [
		{
			img: [{ logo: {position: 'right'}, pic: 'img_01.jpg' }, 'img_02.jpg']
		},
		{
			tel: ['022-6668 4866', '022-6668 4833']
		},
		{
			form: {}
		},
		{
			img: ['img_03.jpg', 'img_04.jpg', 'img_05.jpg', 'img_06.jpg', 'img_07.jpg', 'img_08.jpg', 'img_09.jpg', 'img_10.jpg', 'img_11.jpg', 'img_12.jpg', 'img_13.jpg']
		},
		{
			swiper: {}
		},
		{
			tel: ['022-6668 4833', '022-6668 4866']
		},
		{
			form: {}
		}
	]
};

export default data;
